import { apiClient } from 'utils/API';

export const LEADERBOARD_PAGE_SIZE = 25;

type RawPlayfabContest = {
  version: number;
  startDateUTC: string;
  endDateUTC: string;
};

type RawLeaderboardMetadata = {
  name: string;
  title: string;
  description: string;
  contests?: RawPlayfabContest[];
};

type RawGame = {
  gameId: string;
  gameTitle: string;
  leaderboardsMetadata?: RawLeaderboardMetadata[];
};

export const getGames = async (): Promise<RawGame[]> => {
  const { data } = await apiClient.get<RawGame[]>('/games');

  return data;
};

export type PlayfabProfile = {
  PublisherId: string;
  TitleId: string;
  PlayerId: string;
  DisplayName: string;
};

export type Leaderboard = {
  PlayFabId: string;
  DisplayName?: string;
  StatValue: number;
  Position: number;
  Profile?: PlayfabProfile;
};

type LeaderboardResponse = {
  Leaderboard: Leaderboard[];
};

export type GetLeaderboardOptions = {
  gameId: string;
  contestName: string;
  pageIndex: number;
  version: number;
};

export const getLeaderboard = async ({
  gameId,
  contestName,
  pageIndex,
  version,
}: GetLeaderboardOptions): Promise<Leaderboard[]> => {
  const { data } = await apiClient.get<LeaderboardResponse>(
    `/games/${gameId}/leaderboards/${contestName}`,
    {
      params: {
        skip: LEADERBOARD_PAGE_SIZE * pageIndex,
        take: LEADERBOARD_PAGE_SIZE,
        contestVersion: version,
      },
    },
  );
  return data.Leaderboard;
};

export const getUserScore = async (
  gameId: string,
  leaderboardName: string,
  contestVersion: number,
): Promise<Leaderboard> => {
  const { data } = await apiClient.get<LeaderboardResponse>(
    `/games/${gameId}/leaderboards/${leaderboardName}/current-user-score?contestVersion=${contestVersion}`,
  );

  return data.Leaderboard ? data.Leaderboard[0] : ({} as Leaderboard);
};
